<template>
    <div>
        <el-row :gutter="20" style="padding-bottom: 10px">
            <el-col :span="4">
                <el-input placeholder="请输入操作模块查询" clearable v-model="queryInfo.operateModule" @change="current"
                    @clear="getLogList" :value="queryInfo.operateModule">
                </el-input>
            </el-col>
            <el-col :span="4">
                <el-select v-model="queryInfo.type" placeholder="请选择参数类型" style="width: 100%" filterable>
                    <el-option v-for="item in typeList" :key="item.type" :label="item.label" :value="item.type">
                    </el-option>
                </el-select>
                <!-- <el-input placeholder="请输入操作模块查询" clearable v-model="queryInfo.operateModule" @change="current"
                    @clear="getLogList" :value="queryInfo.operateModule">
                </el-input> -->
            </el-col>
            <el-col :span="5">
                <el-date-picker v-model="value" type="daterange" @blur="pickBlur" :picker-options="pickerOptions"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss" @change="changeTime">
                </el-date-picker>
            </el-col>
            <el-button type="primary" icon="el-icon-search" @click="chaxun">查询</el-button><el-button type="primary"
                icon="el-icon-refresh-left" @click="chongzhi">重置</el-button>
            <!-- <el-col :span="1" style="margin-left: 30px;" v-if="caozuoquanxian">
              <el-button @click="removeById">批量删除</el-button>
            </el-col> -->
        </el-row>
        <!-- 卡片视图区域 登陆日志-->
        <el-card>
            <!--  -->
            <!-- table表格区域 -->
            <el-table :data="logList" border stripe empty-text="暂无数据">
                <el-table-column align="center" label="用户" prop="id" width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.id == null">--</span>
                        <span v-else>{{ scope.row.id }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作模块" prop="operateModule" width="320">
                    <template slot-scope="scope">
                                        <span>{{ scope.row.operateModule }}</span>              
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作类型" prop="operateType" width="240">
                    <template slot-scope="scope">
                                        <span>{{ scope.row.operateType }}</span>              
                    </template>
                </el-table-column>
                <el-table-column align="center" label="接收参数" prop="rawData" width="">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.rawData" placement="top">
                            <span style="width: 60px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{
            scope.row.rawData }}</span>    
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="返回结果" prop="newData" width="">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.newData" placement="top">
                            <span style="width: 60px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{
            scope.row.newData }}</span>    
                        </el-tooltip>    
                    </template>
                </el-table-column>
                <el-table-column align="center" label="创建时间" prop="createTime" width="100px">
                    <template slot-scope="scope">
                        {{ scope.row.createTime }}
                    </template>
                </el-table-column>

            </el-table>
            <!-- 分页导航区域 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.page" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.limit"
                layout="total, sizes, prev, pager, next, jumper" :total="total" background>
            </el-pagination>
        </el-card>
    </div>
</template>

<script>
import caozuo from '@/utils/pubilc.js'
export default {
    name: 'logWorld',
    data() {
        return {
            pickerMinDate: '',
            pickerOptions: {
                onPick: (obj) => {
                    this.pickerMinDate = new Date(obj.minDate).getTime()
                    const start = this.formatDate(obj.minDate, 'start')
                    const end = this.formatDate(obj.maxDate, 'end')
                    obj.maxDate && (this.value = [start, end])
                },
                disabledDate: (time) => {
                    if (this.pickerMinDate) {
                        const oneMonth = 1000 * 3600 * 24 * 31
                        const maxTime = this.pickerMinDate + oneMonth
                        const mixTime = this.pickerMinDate - oneMonth + 1000 * 3600 * 24
                        const tomorrow = new Date(
                            this.formatDate(new Date().getTime() + 1000 * 3600 * 24, 'start')
                        )
                        return (
                            time.getTime() >= tomorrow ||
                            time.getTime() >= maxTime ||
                            time.getTime() < mixTime
                        )
                    }
                },
            },
            caozuoquanxian: false,
            typeList: [
                {
                    type: 0,
                    label: '微信充值'
                },
                {
                    type: 1,
                    label: '微信退款'
                },
                {
                    type: 2,
                    label: '支付宝充值'
                },
                {
                    type: 3,
                    label: '支付宝退款'
                },
                {
                    type: 4,
                    label: '提现'
                },
                {
                    type: 5,
                    label: '转账'
                },
                {
                    type: 6,
                    label: '其他'
                },
                {
                    type: 7,
                    label: '全部'
                }
            ],
            // 查询参数对象
            queryInfo: {
                // 操作模块
                operateModule: '',
                // 操作类型
                operateType: '',
                // 开始时间
                startTime: '',
                // 截止时间
                endTime: '',
                // 返回结果
                newData: '',
                page: 1,
                limit: 10,
                type: 7
            },
            // 商品列表
            logList: [],
            // 总数据条数
            total: 0,
            value: ['', ''],
            ids: '',
        }
    },
    created() {
        caozuo(127).then((res) => {
            this.caozuoquanxian = res
        })
        this.getLogList()
    },
    computed: {
    },
    methods: {
        chaxun() {
            this.queryInfo.page = 1
            this.getLogList()
        },
        pickBlur() {
            this.pickerMinDate = ''
        },
        current() {
            this.queryInfo.page = 1
        },
        changeTime(value) {
            this.queryInfo.page = 1
            if (value) {
                this.queryInfo.startTime = value[0]
                this.queryInfo.endTime = value[1]
            } else {
                this.queryInfo.startTime = ''
                this.queryInfo.endTime = ''
                this.pickerMinDate = ''
                this.getLogList()
            }
        },
        chongzhi() {
            this.queryInfo = {
                // 操作模块
                operateModule: '',
                // 操作类型
                operateType: '',
                // 开始时间
                startTime: '',
                // 截止时间
                endTime: '',
                // 返回结果
                newData: '',
                page: 1,
                limit: 10,
                type:7
            }
            this.value = []
            this.pickerMinDate = ''
            this.getLogList()
        },
        // 根据分页获取对应的日志列表
        async getLogList() {
            if (this.queryInfo.type === 7) {
                this.$delete(this.queryInfo, 'type')
            };
            const { data: res } = await this.$http.get(
                'lkl-operate-log/getAllLklOperateLog',
                { params: this.queryInfo }
            )
            if (res.code !== 0) {
                return this.$message.error(res.msg)
            }
            this.logList = res.data
            this.total = res.count
        },
        // 监听pageSize改变的事件
        handleSizeChange(newSize) {
            this.queryInfo.limit = newSize
            this.queryInfo.page = 1
            this.getLogList()
        },
        // 监听页码值改变的事件
        handleCurrentChange(newPage) {
            this.queryInfo.page = newPage
            this.getLogList()
        },
        // 批量删除的复选框改变事件
        handleSelectionChange(value) {
            if (value.length > 0) {
                this.ids = ''
                value.forEach((item) => {
                    this.ids += item.id + ','
                })
                this.ids = this.ids.substring(0, this.ids.length - 1)
            } else {
                return false
            }
        },
        formatDate(datetime, type) {
            const time = new Date(datetime)
            const year = time.getFullYear()
            const month = (time.getMonth() + 1).toString().padStart(2, '0')
            const date = time.getDate().toString().padStart(2, '0')
            return type === 'start'
                ? year + '-' + month + '-' + date + ' ' + '00' + ':' + '00' + ':' + '00'
                : year + '-' + month + '-' + date + ' ' + '23' + ':' + '59' + ':' + '59'
        },
        getDate() {
            const start = new Date()
            this.value[0] = this.formatDate(
                start.getTime() - 1000 * 3600 * 24 * 30,
                'start'
            )
            this.value[1] = this.formatDate(start.getTime(), 'end')
        }
    },
}
</script>

<style lang="less" scoped></style>
